import { EntityName } from '@provision/entity-types';
import { useEffect } from 'react';
import { EntityViewerStatus } from 'src/graphql/entities/entity-viewer/entity-viewer.types';
import { useEntityViewers } from 'src/graphql/entities/entity-viewer/hooks/use-entity-viewers';
import { useUpdateEntityViewer } from 'src/graphql/entities/entity-viewer/hooks/use-update-entity-viewer';

export const useViewerPresence = ({
  entity,
  entityId,
}: {
  entity: EntityName;
  entityId?: string;
}) => {
  const { updateEntityViewer } = useUpdateEntityViewer({
    entity,
    entityId,
    status: EntityViewerStatus.inactive,
  });

  useEffect(() => {
    // mark active on first render
    void updateEntityViewer(EntityViewerStatus.active).catch(console.error);

    const onHide = () => {
      // try to send reliably on tab close/background
      try {
        void updateEntityViewer(EntityViewerStatus.inactive).catch(console.error);
      } catch {
        // ignore
      }
    };

    const handleHide = () => {
      if (document.visibilityState === 'hidden') onHide();
    };

    // handle SPA unmount + browser lifecycle
    window.addEventListener('pagehide', onHide);
    document.addEventListener('visibilitychange', handleHide);

    return () => {
      document.removeEventListener('visibilitychange', handleHide);
      onHide();
    };
    // empty array - we want useEffect to run on first component's render only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { items: viewers } = useEntityViewers({
    entity,
    entityId,
  });

  return { viewers };
};
